import { createContext, useContext, useEffect, useState, ReactNode } from "react"
import { UserTypeEnum } from "../swagger"

interface UserAuthContextProps {
  isAuthenticated: boolean
  token: string | null
  userType: UserTypeEnum
  login: (token: string, userType: UserTypeEnum) => void
  logout: () => void
  loading: boolean
}

const UserAuthContext = createContext<UserAuthContextProps | null>(null)

export const UserAuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(null)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userType, setUserType] = useState<UserTypeEnum>('APPLICANT')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const storedToken = localStorage.getItem("token")
    const storedUserType = localStorage.getItem("user_type") as UserTypeEnum
    if (storedToken && storedUserType) {
      setToken(storedToken)
      setUserType(storedUserType)
      setIsAuthenticated(true)
    }

    setLoading(false)
  }, [])

  const login = (newToken: string, newUserType: UserTypeEnum) => {
    localStorage.setItem("token", newToken)
    localStorage.setItem("user_type", newUserType || "")
    setToken(newToken)
    setUserType(newUserType)
    setIsAuthenticated(true)
  }

  const logout = () => {
    localStorage.removeItem("token")
    localStorage.removeItem("user_type")
    setToken(null)
    setUserType('APPLICANT')
    setIsAuthenticated(false)
  }

  return (
    <UserAuthContext.Provider
      value={{ isAuthenticated, token, userType, login, logout, loading }}
    >
      {children}
    </UserAuthContext.Provider>
  )
}

export const useUserAuth = () => {
  const context = useContext(UserAuthContext)
  if (!context) throw new Error("useUserAuth must be used inside UserAuthProvider")
  return context
}
